<template lang="html">
  <div class="college_main">
    <div @click="hideList()">
      <div class="title">
        <img src="../../../../public/filledu_LOGO.png" alt="" style="width:200px; display:block; margin:30px auto" />
          <p style="text-align:center;">필드유 대학 정보 시스템</p>
        </div>
        <div class="sort_list" style="width:1000px; margin:200px auto 20px auto">
          <div style="display:flex; justify-content:center">
            <vs-select
              label="지역별"
              v-model="selected"
              style="margin-top:5px; width:160px;">
              <vs-select-item
                v-for="(item, index) in localList"
                :key="index"
                :value="item.text"
                :text="item.text"/>
            </vs-select>
            <vx-card style="width:800px; margin: 20px auto auto 10px; box-shadow: 0px 5px 10px 0px rgb(0 0 0 / 10%); border-radius:8px; padding:15px">
              <table>
                <thead>
                  <tr style="background-color: #f9f9f9;">
                    <th style="width:43%" rowspan="2">대학명</th>
                    <th style="width:20%" rowspan="2">대학 구분</th>
                    <th style="width:18%" rowspan="2">대학 설립 유형</th>
                    <th rowspan="2">지역</th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="goForm(item)" @getList="appearUnivInfo()" v-if="item.region == selected" v-for="(item , index) in local" :key="index">
                      <td class="list_form">{{item.name}}({{item.campus_name}})</td>
                      <td style="text-align:center">{{item.school_gubun}}</td>
                      <td style="text-align:center">{{item.set_type}}</td>
                      <td style="text-align:center">{{item.region}}</td>
                    </tr>
                </tbody>
              </table>
                <!-- <vs-button color="success" style="width:630px; height:35px; margin-top:15px" type="flat" icon-pack="feather" size="medium" icon="icon-plus" @click="popupState = !popupState">대학 추가</vs-button> -->
            </vx-card>
          </div>
      </div>
    </div>
    <div style="width:500px; position:absolute; top:250px; left:50%; transform:translateX(-50%)"
       @keyup.down="selectValue('down')"
       @keyup.up="selectValue('up')">
       <div style="position:absolute; z-index:1">
         <input type="text" :style="{borderRadius : inputRadius}" @focus="showList()"
              style="position:relative; height:45px; border-radius:30px"
              placeholder="대학 또는 학과 검색"
              v-model="search" />
      <search-icon style="z-index:2; position:absolute; left:15px; top:12px;" size="1.5x" class="custom-class"></search-icon>
      </div>
    <div :style='{display : activeDisplay}' v-if="search != ''" style="width:100%; position:absolute; padding-top:10px; background:white; top:35px; z-index:999; border-radius: 0 0 5px 5px; box-shadow:0 8px 6px 1px rgba(200, 200, 200, 0.7) ;">
      <ul class="college_list" ref="college_list" :class="{active : isActive}">
        <li @click="goForm(item)" tabindex="-1" @keypress.enter="goForm(item)" style="display:flex; padding:5px 20px; justify-content: space-between;" v-for="(item , index) in college" :key="index">
          <div style="margin:5px 0">
            <search-icon style="margin:0 5px -2px 0" size="1x" class="custom-class"></search-icon>
            <span style="margin-left:30px;">{{item.name}}({{item.campus_name}})</span>
          </div>
          <arrow-up-right-icon style="margin-top:3px;" size="1.5x" class="custom-class"></arrow-up-right-icon>
        </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
import {
  SearchIcon,
  ArrowUpRightIcon,
  PlusIcon
 } from 'vue-feather-icons'

import Modal from '@/views/pages/admin-college/Modal.vue'

export default {
  components: {
    SearchIcon,
    ArrowUpRightIcon,
    PlusIcon,
    Modal,
  },
  data() {
    return {
      selected: '서울특별시',
      localList: [
        {text:'서울특별시' , value: '1' , group: '0'},
        {text:'경기도' , value: '2', group: '1'},
        {text:'인천광역시' , value: '3', group: '0'},
        {text:'대전광역시' , value: '4', group: '0'},
        {text:'부산광역시' , value: '5', group: '0'},
        {text:'광주광역시' , value: '6', group: '0'},
        {text:'울산광역시' , value: '7', group: '0'},
        {text:'대구광역시' , value: '8', group: '0'},
        {text:'강원도' , value: '9', group: '1'},
        {text:'충청남도' , value: '10', group: '1'},
        {text:'충청북도' , value: '11', group: '1'},
        {text:'전라남도' , value: '12', group: '1'},
        {text:'전라북도' , value: '13', group: '1'},
        {text:'경상남도' , value: '14', group: '1'},
        {text:'경상북도' , value: '15', group: '1'},
        {text:'세종특별자치시' , value: '16', group: '0'},
        {text:'제주특별자치도' , value: '17', group: '0'},
      ],
      isActive: false,
      activeDisplay: 'none',
      inputRadius: '30px',
      search: '',
      counter : 0,
      value: 0,
      sortLocal: '',
      popupState: false,
      school: []
    }
  },
  watch: {
    selected() {
      this.sortCollegeList()
    },
    search(val) {
      const reg = /[a-z|A-Z|0-9]/
      if(this.search != "") {
        if(reg.exec(val) != null) {
          return this.search = ''
        }
        this.showList()
      } else {
        this.hideList()
      }
      this.$store.commit('etest/UPDATE_KEYWORD' , this.search)
    },
    popupState() {
      console.log(this.popupState)
    },
  },
  created() {
    document.onkeydown = (e)=> {
     if(e.keyCode == 38 || e.keyCode == 40) {
       e.preventDefault()
     }
    }
    this.appearUnivInfo()
    // console.log(this.local)
    // this.sortLocal = JSON.parse(JSON.stringify(this.univList))
    // this.sortCollegeList()
    // this.appearUnivInfo()

  },
  methods: {
    test() {
      if(this.activeDisplay == 'block') {
        this.hideList()
      }
      console.log('123')
    },
    hideList() {
        this.activeDisplay = "none"
        this.inputRadius = '30px'
    },
    showList() {
      if(this.search != '') {
        this.activeDisplay = "block"
        this.inputRadius = '5px'
        this.isActive = true;
      }
    },
    // sortCollegeList() {
    //   this.sortLocal.sort((a,b) => {
    //     return a.name.localeCompare(b.name)
    //   })
    // },


    // addList() {
    //   console.log('추가')
    // },
    selectValue(val) {
      console.log('1')
      if (this.isActive && this.college.length > 0) {
        const hasClass = document.querySelector('.college_list').classList.contains('key')
        if (val == 'down') {
          if (!hasClass) {
            document.querySelector('.college_list').classList.add('key')
            const thisEl = document.querySelector('.college_list li:first-child')
            thisEl.classList.add('sel')
            document.querySelector('.sel').focus()
          } else {
            const lastEl = document.querySelector('.college_list li:last-child')
            const thisEl = document.querySelector('.sel')
            const nextEl = thisEl.nextElementSibling
            if (!lastEl.classList.contains('sel')) {
              thisEl.classList.remove('sel')
              nextEl.classList.add('sel')
              document.querySelector('.sel').focus()
            } else {
              thisEl.classList.remove('sel')
              document.querySelector('.college_list li:first-child').classList.add('sel')
            }
          }
        }
        if (val == 'up' && hasClass) {
          const firstEl = document.querySelectorAll('.key li')[0]
          const thisEl = document.querySelector('.sel')
          const prevEl = thisEl.previousElementSibling
          if (!firstEl.classList.contains('sel')) {
            thisEl.classList.remove('sel')
            prevEl.classList.add('sel')
            prevEl.focus();
          } else {
            thisEl.classList.remove('sel')
            document.querySelector('.college_list li:last-child').classList.add('sel')
            document.querySelector('.college_list').focus()
          }
        }
      } else {
        return
      }
    },
    goForm(val) {
      console.log(val)
      this.$store.commit('etest/SET_COLLEGE_INFO' , val)
      this.$store.dispatch('etest/getMajorList' , val.id).then(()=> {
        if(this.majorList.length) {
          this.$store.dispatch('etest/getMajorGrdList' , this.majorList[0].id).then(()=> {
            this.$router.push('/apps/admin/college-simply')
          })
        } else {
          this.$router.push('/apps/admin/college-simply')
        }
      })
      // this.$store.commit('etest/SET_ACTIVE_MAJOR_INFO' , val.id)
      // this.$store.commit('etest/SET_ACTIVE_SCORE_LIST' , val.id)
    },
    appearUnivInfo() {
      this.$store.dispatch('etest/showUniv')
       .then(()=>{
        // console.log(this.univList)
        // for(var i=0; i < this.univList.length; i++){
        //   this.school[i] = this.univList[i].name
        //   console.log(this.school[i])
        // }

        // this.sortLocal = JSON.parse(JSON.stringify(this.univList))
        // this.sortCollegeList()

        })
        .catch(() => {
          this.$vs.notify({
            color: 'orange',
            title: '실패',
            text: ''
          })
        })
     },
  },
  computed: {
    college() {
      return this.$store.getters['etest/filteredCollege']
    },
    collegeInfo() {
      return this.$store.state.etest.univList
    },
    univList(){
      return this.$store.state.etest.univList
    },
    local() {
      return this.$store.getters['etest/sortedUnivName']
    },
    majorList() {
      return this.$store.state.etest.majorList
    },
  }
}
</script>

<style lang="css">
    #content-area, .content-wrapper {
      min-height: 700px!important
    }
    input {
        width: 500px;
        border:0;
        box-shadow: 0px 0px 7px rgb(0 0 0 / 20%);
        padding: 0 20px 0 50px;
    }
    .college_list li:hover {
      background: #ddd;
      cursor: pointer
    }
    .addList:hover {
      background: #ddd;
      cursor: pointer
    }
    .sel {
      background: #ddd;
    }
    .list_form:hover {
      cursor: pointer;
      color: #333;
      text-decoration: underline;
    }
    .college_main .active {
      display:block
    }

    table {
      margin-top:-10px;
      width: 100%;
      border-top: 2px solid lightgray;
      border-top: 2px solid lightgray;
      border-collapse: collapse;
    }
    th {
      font-size: 14px;
      text-align:center;
    }
    th, td {
      border-bottom: 1px solid lightgray;
      border-left: 1px solid lightgray;
      padding: 10px;
    }
    th:first-child, td:first-child {
      border-left: none;
    }

    .addUniv textarea{
      padding: 6px 5px;
    }
</style>
